import APIs from '../../api'
import { apiClient } from '../../api/client'

// Resolve the company name shown in the "Company information" section.
// Consumes the cached /guardian-users/me payload (stored in localStorage by
// ProductSelection after login) — no extra fetch. Falls through to '' so
// the caller can decide whether to render the static 'MdG Srl' default.
// Trims trailing whitespace the server tacks on names
// (e.g. "Anupam Infotech ").
const resolveCompanyName = (me) => {
  if (!me) return ''
  const raw = me.type === 'COMPANY' ? me.name : me.type === 'USER' ? me.parentCompany?.name : null
  return typeof raw === 'string' ? raw.trim() : ''
}

// GET /api/global-settings — user-scoped preferences. Returns:
//   {
//     defaultLanguage, defaultTimezone, temperatureUnit,
//     smsNotifications, voiceNotifications,
//     recalibrationReminder (boolean), alarmConfirmation,
//     remoteLogin, remoteSupport, fda21CfrPart11
//   }
const getGlobalSettings = async () => {
  const res = await apiClient.get(APIs.GLOBAL_SETTINGS.get)
  return res?.data?.data ?? res?.data ?? null
}

// PUT /api/global-settings — same keys as the GET response. Caller hands in
// only the fields they want to persist; the backend treats omitted fields
// as "keep current value".
const updateGlobalSettings = async (payload) => {
  const res = await apiClient.put(APIs.GLOBAL_SETTINGS.update, payload)
  return res?.data?.data ?? res?.data ?? null
}

export { getGlobalSettings, updateGlobalSettings, resolveCompanyName }
